import React from 'react';

export function Button({onClick, status, children, btnStyle='primary', style}) {
  let buttonStyle = 'btn-' + btnStyle;
  return (
    <button className={`btn ${buttonStyle}`} onClick={onClick} type="button" disabled={status === 'pending'} style={style}>
      {status === 'pending' && <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
      {children}
    </button>
  );
}